
import { ChangeDetectionStrategy, Component, DestroyRef, EventEmitter, inject, Input, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ButtonDirective } from '@portal/ui-common';
import { finalize } from 'rxjs';
import { PositionErrors } from '../../models/position-errors.model';
import { AutofillLocationService } from '../../services/autofill-location.service';

@Component({
  selector: 'csl-autofill-location',
  standalone: true,
  imports: [ButtonDirective],
  templateUrl: './autofill-location.component.html',
  styleUrl: './autofill-location.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AutofillLocationService],
})
export class AutofillLocationComponent {
  private readonly geoService = inject(AutofillLocationService);
  private readonly destroyedRef = inject(DestroyRef);

  @Input() set hideWarning(value: unknown) {
    if (this.hasError === true) {
      this.hasError = false;
    }
  }

  @Output() positionSelect = new EventEmitter<GeolocationCoordinates | null | PositionErrors>();

  inProgress = false;
  hasError = false;

  getCoordinates(): void {
    this.inProgress = true;
    this.hasError = false;

    this.geoService
      .getCurrentLocation()
      .pipe(
        takeUntilDestroyed(this.destroyedRef),
        finalize(() => (this.inProgress = false)),
      )
      .subscribe({
        error: (err: Partial<{ code: number; message: string }>) => {
          this.hasError = true;

          const fail =
            err?.code === PositionErrors.PositionUnavailable
              ? PositionErrors.PositionUnavailable
              : PositionErrors.PermissionDenied;

          this.positionSelect.emit(fail);
        },
        next: (position: GeolocationPosition) => {
          this.positionSelect.emit(position.coords);
        },
      });
  }

  /** 
  * Test methods for test buttons
  *   
  getTestCoordinates(): void {
    this.positionSelect.emit(TEST_COORDINATES_FOR_BURLINGTON);
  }

  getTrashAndRecycleCoordinates(): void {
    this.positionSelect.emit(TEST_COORDINATES_FOR_SHELDON);
  }
  */
}
